<template>
  <div class="market-invitingFriendsRecord-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #bindingTime="{ row }">{{ row.bindingTime || '---' }}</template>
      <template #inviter="{ row, scope }">
        <span :key="inviter_show">{{ row.inviter_show || row.inviter }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.inviter" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index,'inviter_show',row.userId)">
            {{ row.inviter_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #platform="{ row }">{{ row.platform || '---' }}</template>
      <template #description="{ row }">{{ row.description || '---' }}</template>
      <template #invitee="{ row, scope }">
        <span :key="invitee_show">{{ row.invitee_show || row.invitee }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.invitee" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index,'invitee_show',row.inviteeId)">
            {{ row.invitee_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import aes from '@/common/aes.js'
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getInviteRecordList} from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import { formatArrTime } from '@/utils/index'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mInvitingFriendsRecord",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table
  },
  data() {

    return {
      renderData: [
        {
          label: "邀请人账号",
          placeholder: "请输入邀请人账号",
          type: "input",
          key: "inviter",
        },
        {
          label: "被邀请人账号",
          placeholder: "请输入被邀请人账号",
          type: "input",
          key: "invitee",
        },
        {
          label: "绑定时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time"
        },
      ],
      form: {},
      inviter_show:false,
      invitee_show:false,
      tableThData: [
        { prop: "bindingTime", label: "绑定时间", minWidth: "120", },
        { prop: "inviter", label: "邀请人", minWidth: "120", },
        { prop: "platform", label: "客户端", minWidth: "180", },
        { prop: "description", label: "绑定方式", minWidth: "120", },
        { prop: "invitee", label: "被邀请人", minWidth: "180", },
      ],
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let {start, end} = formatArrTime(this.form.time, 'YYYY-MM-DD HH:mm:ss')
      params.bindingBeginTime = start
      params.bindingEndTime = end
      delete params.time
      const data = await api_getInviteRecordList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
      this.showImport = true
    },
    // 点击查看手机号
    async onLookPhone(row, index, key, userId) {
      console.log()
      try {
        if (row[key]) {
          delete this.tableTrData[index][key]
        } else {
          const {phone} = await api_getUserPhone({id: userId})
          this.tableTrData[index][key] = aes.decrypt(phone)
        }
        this[key] = !this[key]
      } catch (error) {
        console.log('error: ', error);
      }
    }
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-invitingFriendsRecord-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    .down-btn {
      padding: 0 10px;
    }
  }

  .copy {
    color: #05C8AF;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
